const NotFound = () => {
  return(
    <div className="Page">
      <h1>404</h1>
      <p>Упс... похоже данной страницы не существует</p>
    </div>
  );
}
export default NotFound